<template>
  <div class="ali-player" ref="video_box" style="height: 100%; width: 100%">
    <div class="video-box" style="height: 100%; width: 100%">
      <video-player
        class="video-player vjs-custom-skin"
        style="height: 100%; width: 100%"
        ref="videoPlayer"
        :options="playerOptions"
        @ready="onPlayerReadied"
        @timeupdate="onTimeupdate"
        @play="onPlayerPlay()"
        @pause="onPlayerPause()"
        @error="onError($event)"
        crossOrigin="Anonymous"
        webkit-playsinline="true"
        :playsinline='videoScreen'
        x5-video-player-type="h5-page"
      >
      </video-player>
      <div class="mask"  @click="changRefs"></div>
      <div class="zs_control_bar_player" ref="controlBbar">
        <div
          v-if="liveTimeShiftFlag"
          class="timeshiftbtn_player"
          id="timeshiftbtn_player"
          ison="true"
        >
          <div id="timeshiftbtn_text_player" class="timeshiftbtn_text_player">
            时移
          </div>

          <div @click="showProess" class="timeshiftbtn_image_player">
            <!-- 时移选中背景 -->
            <img
              v-if="isProess"
              class="timeshiftbtn_true_player"
              id="timeshiftbtn_true_player"
              src="@/assets/zsLiveImage/time_shift_selected_back.png"
            />
            <!-- 时移未选中背景 -->
            <img
              v-if="!isProess"
              class="timeshiftbtn_false_player"
              id="timeshiftbtn_false_player"
              src="@/assets/zsLiveImage/time_shift_no_selected_back.png"
            />
            <!-- 时移point -->
            <div
              id="timeshiftbtn_pointer_player"
              class="timeshiftbtn_pointer_true_player"
              :style="{ right: isProess ? '0px' : '18px' }"
            >
              <img
                style="width: 20px; height: 20px"
                src="@/assets/zsLiveImage/time_shift_swich.png"
              />
            </div>
          </div>
        </div>

        <!-- <div id="date_list_player" v-if="openData">
          <div
            class="program-list"
            v-for="(item, index) in program"
            :key="index"
            @click="getDatePro(item, index)"
            :class="proIndex == index ? 'is-active' : ''"
          >
            <div style="padding: 15px 0px" v-if="index < program.length - 1">
              {{ item.week }}
            </div>
            <div style="padding: 15px 0px" v-else>今日</div>
          </div>

          <div
            style="
              position: relative;
              height: 12px;
              padding: 0px 10px;
              margin: 0px;
              opacity: 0;
              width: 40px;
              color: rgb(255, 255, 255);
            "
          ></div>
        </div> -->

        <div v-if="isProess" id="timeshift_bar_player">
          <!-- 日期 -->
          <div
            id="date_show_player"
            style="
              position: absolute;
              height: 50px;
              width: 60px;
              bottom: 0px;
              left: 0px;
              margin: 0px;
              padding: 0px;
              border-right: 1px solid rgb(90, 90, 90);
              overflow: hidden;
              border-bottom: 1px solid rgb(90, 90, 90);
              cursor: pointer;
            "
          >
            <div
              id="date_playing_player"
              style="
                position: relative;
                margin: 0px auto;
                height: 25px;
                width: 59px;
                text-align: center;
                line-height: 30px;
                vertical-align: bottom;
              "
            >
              今日
            </div>

            <div
              id="timeshift_date_player"
              style="
                position: relative;
                margin: 0px auto;
                height: 25px;
                width: 59px;
                text-align: center;
                line-height: 16px;
                vertical-align: top;
              "
            >
              {{ format(new Date(),'MM/dd') }}
            </div>
          </div>

          <!-- 时间节点 -->
          <div id="timeshift_scale_player" ref="scaleWidth">
            <div
              id="scale_player"
              ref="scalePlayer"
              style="left: 0px"
              @click="getPointerNode"
            >
              <div style="position: absolute; left: 4px; bottom: 3px">
                00:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 18px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 36px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 54px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 72px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 94px; bottom: 3px">
                00:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 90px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 108px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 126px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 144px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 162px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 184px; bottom: 3px">
                00:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 180px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 198px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 216px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 234px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 252px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 274px; bottom: 3px">
                00:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 270px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 288px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 306px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 324px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 342px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 364px; bottom: 3px">
                00:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 360px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 378px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 396px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 414px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 432px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 454px; bottom: 3px">
                00:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 450px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 468px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 486px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 504px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 522px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 544px; bottom: 3px">
                01:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 540px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 558px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 576px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 594px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 612px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 634px; bottom: 3px">
                01:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 630px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 648px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 666px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 684px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 702px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 724px; bottom: 3px">
                01:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 720px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 738px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 756px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 774px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 792px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 814px; bottom: 3px">
                01:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 810px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 828px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 846px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 864px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 882px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 904px; bottom: 3px">
                01:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 900px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 918px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 936px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 954px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 972px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 994px; bottom: 3px">
                01:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 990px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1008px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1026px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1044px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1062px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1084px; bottom: 3px">
                02:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1080px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1098px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1116px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1134px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1152px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1174px; bottom: 3px">
                02:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1170px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1188px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1206px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1224px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1242px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1264px; bottom: 3px">
                02:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1260px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1278px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1296px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1314px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1332px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1354px; bottom: 3px">
                02:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1350px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1368px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1386px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1404px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1422px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1444px; bottom: 3px">
                02:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1440px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1458px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1476px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1494px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1512px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1534px; bottom: 3px">
                02:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1530px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1548px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1566px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1584px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1602px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1624px; bottom: 3px">
                03:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1620px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1638px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1656px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1674px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1692px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1714px; bottom: 3px">
                03:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1710px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1728px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1746px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1764px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1782px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1804px; bottom: 3px">
                03:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1800px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1818px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1836px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1854px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1872px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1894px; bottom: 3px">
                03:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1890px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1908px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1926px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1944px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1962px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 1984px; bottom: 3px">
                03:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 1980px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 1998px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2016px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2034px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2052px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2074px; bottom: 3px">
                03:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2070px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2088px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2106px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2124px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2142px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2164px; bottom: 3px">
                04:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2160px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2178px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2196px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2214px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2232px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2254px; bottom: 3px">
                04:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2250px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2268px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2286px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2304px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2322px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2344px; bottom: 3px">
                04:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2340px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2358px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2376px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2394px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2412px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2434px; bottom: 3px">
                04:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2430px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2448px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2466px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2484px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2502px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2524px; bottom: 3px">
                04:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2520px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2538px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2556px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2574px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2592px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2614px; bottom: 3px">
                04:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2610px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2628px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2646px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2664px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2682px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2704px; bottom: 3px">
                05:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2700px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2718px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2736px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2754px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2772px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2794px; bottom: 3px">
                05:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2790px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2808px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2826px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2844px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2862px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2884px; bottom: 3px">
                05:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2880px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2898px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2916px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2934px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2952px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 2974px; bottom: 3px">
                05:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 2970px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 2988px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3006px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3024px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3042px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3064px; bottom: 3px">
                05:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3060px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3078px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3096px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3114px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3132px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3154px; bottom: 3px">
                05:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3150px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3168px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3186px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3204px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3222px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3244px; bottom: 3px">
                06:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3240px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3258px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3276px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3294px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3312px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3334px; bottom: 3px">
                06:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3330px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3348px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3366px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3384px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3402px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3424px; bottom: 3px">
                06:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3420px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3438px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3456px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3474px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3492px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3514px; bottom: 3px">
                06:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3510px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3528px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3546px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3564px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3582px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3604px; bottom: 3px">
                06:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3600px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3618px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3636px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3654px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3672px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3694px; bottom: 3px">
                06:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3690px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3708px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3726px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3744px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3762px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3784px; bottom: 3px">
                07:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3780px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3798px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3816px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3834px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3852px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3874px; bottom: 3px">
                07:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3870px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3888px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3906px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3924px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3942px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 3964px; bottom: 3px">
                07:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 3960px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3978px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 3996px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4014px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4032px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4054px; bottom: 3px">
                07:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4050px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4068px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4086px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4104px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4122px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4144px; bottom: 3px">
                07:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4140px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4158px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4176px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4194px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4212px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4234px; bottom: 3px">
                07:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4230px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4248px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4266px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4284px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4302px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4324px; bottom: 3px">
                08:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4320px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4338px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4356px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4374px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4392px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4414px; bottom: 3px">
                08:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4410px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4428px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4446px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4464px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4482px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4504px; bottom: 3px">
                08:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4500px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4518px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4536px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4554px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4572px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4594px; bottom: 3px">
                08:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4590px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4608px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4626px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4644px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4662px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4684px; bottom: 3px">
                08:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4680px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4698px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4716px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4734px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4752px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4774px; bottom: 3px">
                08:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4770px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4788px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4806px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4824px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4842px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4864px; bottom: 3px">
                09:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4860px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4878px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4896px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4914px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4932px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 4954px; bottom: 3px">
                09:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 4950px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4968px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 4986px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5004px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5022px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5044px; bottom: 3px">
                09:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5040px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5058px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5076px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5094px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5112px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5134px; bottom: 3px">
                09:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5130px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5148px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5166px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5184px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5202px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5224px; bottom: 3px">
                09:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5220px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5238px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5256px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5274px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5292px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5314px; bottom: 3px">
                09:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5310px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5328px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5346px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5364px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5382px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5404px; bottom: 3px">
                10:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5400px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5418px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5436px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5454px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5472px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5494px; bottom: 3px">
                10:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5490px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5508px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5526px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5544px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5562px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5584px; bottom: 3px">
                10:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5580px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5598px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5616px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5634px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5652px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5674px; bottom: 3px">
                10:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5670px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5688px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5706px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5724px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5742px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5764px; bottom: 3px">
                10:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5760px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5778px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5796px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5814px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5832px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5854px; bottom: 3px">
                10:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5850px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5868px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5886px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5904px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5922px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 5944px; bottom: 3px">
                11:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 5940px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5958px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5976px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 5994px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6012px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6034px; bottom: 3px">
                11:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6030px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6048px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6066px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6084px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6102px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6124px; bottom: 3px">
                11:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6120px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6138px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6156px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6174px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6192px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6214px; bottom: 3px">
                11:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6210px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6228px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6246px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6264px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6282px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6304px; bottom: 3px">
                11:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6300px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6318px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6336px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6354px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6372px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6394px; bottom: 3px">
                11:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6390px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6408px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6426px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6444px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6462px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6484px; bottom: 3px">
                12:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6480px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6498px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6516px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6534px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6552px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6574px; bottom: 3px">
                12:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6570px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6588px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6606px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6624px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6642px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6664px; bottom: 3px">
                12:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6660px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6678px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6696px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6714px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6732px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6754px; bottom: 3px">
                12:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6750px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6768px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6786px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6804px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6822px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6844px; bottom: 3px">
                12:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6840px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6858px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6876px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6894px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6912px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 6934px; bottom: 3px">
                12:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 6930px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6948px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6966px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 6984px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7002px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7024px; bottom: 3px">
                13:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7020px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7038px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7056px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7074px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7092px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7114px; bottom: 3px">
                13:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7110px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7128px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7146px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7164px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7182px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7204px; bottom: 3px">
                13:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7200px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7218px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7236px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7254px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7272px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7294px; bottom: 3px">
                13:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7290px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7308px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7326px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7344px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7362px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7384px; bottom: 3px">
                13:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7380px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7398px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7416px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7434px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7452px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7474px; bottom: 3px">
                13:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7470px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7488px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7506px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7524px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7542px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7564px; bottom: 3px">
                14:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7560px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7578px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7596px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7614px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7632px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7654px; bottom: 3px">
                14:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7650px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7668px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7686px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7704px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7722px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7744px; bottom: 3px">
                14:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7740px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7758px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7776px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7794px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7812px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7834px; bottom: 3px">
                14:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7830px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7848px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7866px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7884px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7902px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 7924px; bottom: 3px">
                14:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 7920px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7938px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7956px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7974px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 7992px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8014px; bottom: 3px">
                14:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8010px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8028px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8046px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8064px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8082px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8104px; bottom: 3px">
                15:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8100px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8118px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8136px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8154px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8172px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8194px; bottom: 3px">
                15:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8190px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8208px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8226px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8244px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8262px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8284px; bottom: 3px">
                15:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8280px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8298px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8316px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8334px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8352px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8374px; bottom: 3px">
                15:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8370px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8388px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8406px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8424px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8442px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8464px; bottom: 3px">
                15:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8460px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8478px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8496px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8514px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8532px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8554px; bottom: 3px">
                15:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8550px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8568px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8586px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8604px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8622px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8644px; bottom: 3px">
                16:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8640px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8658px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8676px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8694px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8712px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8734px; bottom: 3px">
                16:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8730px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8748px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8766px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8784px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8802px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8824px; bottom: 3px">
                16:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8820px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8838px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8856px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8874px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8892px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 8914px; bottom: 3px">
                16:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 8910px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8928px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8946px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8964px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 8982px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9004px; bottom: 3px">
                16:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9000px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9018px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9036px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9054px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9072px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9094px; bottom: 3px">
                16:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9090px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9108px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9126px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9144px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9162px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9184px; bottom: 3px">
                17:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9180px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9198px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9216px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9234px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9252px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9274px; bottom: 3px">
                17:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9270px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9288px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9306px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9324px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9342px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9364px; bottom: 3px">
                17:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9360px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9378px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9396px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9414px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9432px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9454px; bottom: 3px">
                17:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9450px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9468px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9486px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9504px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9522px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9544px; bottom: 3px">
                17:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9540px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9558px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9576px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9594px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9612px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9634px; bottom: 3px">
                17:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9630px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9648px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9666px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9684px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9702px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9724px; bottom: 3px">
                18:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9720px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9738px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9756px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9774px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9792px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9814px; bottom: 3px">
                18:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9810px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9828px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9846px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9864px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9882px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9904px; bottom: 3px">
                18:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9900px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9918px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9936px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9954px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 9972px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 9994px; bottom: 3px">
                18:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 9990px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10008px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10026px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10044px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10062px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10084px; bottom: 3px">
                18:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10080px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10098px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10116px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10134px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10152px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10174px; bottom: 3px">
                18:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10170px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10188px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10206px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10224px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10242px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10264px; bottom: 3px">
                19:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10260px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10278px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10296px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10314px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10332px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10354px; bottom: 3px">
                19:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10350px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10368px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10386px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10404px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10422px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10444px; bottom: 3px">
                19:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10440px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10458px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10476px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10494px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10512px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10534px; bottom: 3px">
                19:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10530px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10548px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10566px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10584px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10602px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10624px; bottom: 3px">
                19:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10620px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10638px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10656px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10674px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10692px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10714px; bottom: 3px">
                19:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10710px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10728px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10746px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10764px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10782px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10804px; bottom: 3px">
                20:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10800px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10818px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10836px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10854px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10872px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10894px; bottom: 3px">
                20:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10890px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10908px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10926px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10944px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10962px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 10984px; bottom: 3px">
                20:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 10980px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 10998px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11016px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11034px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11052px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11074px; bottom: 3px">
                20:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11070px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11088px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11106px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11124px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11142px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11164px; bottom: 3px">
                20:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11160px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11178px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11196px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11214px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11232px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11254px; bottom: 3px">
                20:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11250px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11268px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11286px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11304px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11322px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11344px; bottom: 3px">
                21:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11340px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11358px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11376px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11394px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11412px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11434px; bottom: 3px">
                21:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11430px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11448px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11466px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11484px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11502px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11524px; bottom: 3px">
                21:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11520px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11538px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11556px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11574px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11592px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11614px; bottom: 3px">
                21:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11610px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11628px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11646px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11664px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11682px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11704px; bottom: 3px">
                21:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11700px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11718px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11736px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11754px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11772px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11794px; bottom: 3px">
                21:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11790px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11808px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11826px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11844px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11862px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11884px; bottom: 3px">
                22:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11880px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11898px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11916px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11934px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11952px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 11974px; bottom: 3px">
                22:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 11970px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 11988px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12006px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12024px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12042px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12064px; bottom: 3px">
                22:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12060px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12078px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12096px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12114px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12132px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12154px; bottom: 3px">
                22:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12150px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12168px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12186px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12204px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12222px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12244px; bottom: 3px">
                22:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12240px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12258px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12276px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12294px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12312px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12334px; bottom: 3px">
                22:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12330px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12348px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12366px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12384px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12402px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12424px; bottom: 3px">
                23:00
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12420px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12438px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12456px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12474px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12492px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12514px; bottom: 3px">
                23:10
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12510px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12528px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12546px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12564px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12582px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12604px; bottom: 3px">
                23:20
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12600px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12618px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12636px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12654px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12672px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12694px; bottom: 3px">
                23:30
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12690px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12708px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12726px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12744px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12762px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12784px; bottom: 3px">
                23:40
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12780px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12798px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12816px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12834px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12852px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div style="position: absolute; left: 12874px; bottom: 3px">
                23:50
              </div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 37px;
                  left: 12870px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12888px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12906px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12924px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
              <div
                style="
                  position: absolute;
                  width: 1px;
                  height: 4px;
                  left: 12942px;
                  bottom: 0px;
                  background-color: rgb(90, 90, 90);
                "
              ></div>
            </div>
          </div>

          <!-- 节目列表 -->
          <div id="timeshift_epg_player" ref="epgWidth">
            <div id="epg_player" ref="epgPlayer" style="left: -30px">
              <div
                class="program_item"
                :class="{
                  program_item_playing: isDuringDate(
                    item.livePlayTime,
                    format(
                      new Date(item.livePlayTime).getTime() +
                        item.liveProgramTimeLength * 1000,
                      'yyyy-MM-dd HH:mm:ss'
                    )
                  ),
                }"
                @click="handleClickProgramItem(item)"
                :style="{
                  width: item.liveProgramTimeLength * 0.15 + 'px',
                  left: makeDurationToSeconds(item.startTime) * 0.15 + 'px',
                }"
                v-for="(item, index) in programList"
                :key="index"
              >
                {{ item.liveProgramName }}
              </div>
            </div>
          </div>
          <!-- 左右按钮 -->
          <div
            id="epg_left_shift_player"
            @click="leftClick"
            style="
              position: absolute;
              left: 60px;
              bottom: 0px;
              width: 30px;
              height: 23px;
              cursor: pointer;
              z-index: 20;
              border-bottom: 1px solid rgb(90, 90, 90);
            "
          >
            <img
              id="epg_leftarrow_mouseover_player "
              class="left-no-mous epg-player-btn first-epg"
              src="@/assets/ckVideo/epg_left.png"
            />
            <img
              class="left-mous epg-player-btn second-epg"
              id="epg_leftarrow_mouseover_player"
              src="@/assets/ckVideo/epg_left_mouseover.png"
            />
          </div>
          <div
            id="epg_right_shift_player"
            @click="rightClick"
            style="
              position: absolute;
              right: 0px;
              bottom: 0px;
              width: 30px;
              height: 23px;
              cursor: pointer;
              z-index: 200;
              border-bottom: 1px solid rgb(90, 90, 90);
            "
          >
            <img
              id="epg_rightarrow_mouseover_player"
              class="right-no-mous epg-player-btn first-epg"
              src="@/assets/ckVideo/epg_right.png"
            />
            <img
              class="right-mous epg-player-btn second-epg"
              id="epg_rightarrow_mouseover_player"
              src="@/assets/ckVideo/epg_right_mouseover.png"
            />
          </div>
        </div>
        <div
          v-if="isProess"
          id="timeshift_pointer_player"
          ref="pointer"
          style="left: 300px"
          @mousedown="getPointer"
        >
          <img
            src="@/assets/zsLiveImage/video_timeShift_icon.png"
            style="width: 20px; height: 70px"
            data-spm-anchor-id="C28340.P4hQlpYBT2vN.EqnoGmEvxA85.i6"
          />
        </div>

        <!-- 清晰度切换 -->
        <div class="video_definition_change_content" v-if="resolutionSwitch">
          <div class="video_definition_now" @click="handleClickDefinition">
            {{ definitionDefaultName }}
          </div>
          <div class="video_definition_change_body" v-if="videoDefinitionShow">
            <!-- <div class="video_definition_change_item video_definition_item_now">超清</div> -->
            <div
              class="video_definition_change_item"
              :class="{ video_definition_item_now: item.active }"
              @click="handleChangeDefinition(item, index)"
              v-for="(item, index) in resolution"
              :key="index"
            >
              {{ item.liveTvResolutionName }}
            </div>
          </div>
        </div>
        <!-- 音量 -->
        <div
          id="player_sound_btn_player"
          volume="50"
          ismute="false"
          @click="handleClickVolumn"
        >
          <!-- @click="showSound" -->

          <img
            v-if="!sound"
            id="player_sound_yes_player"
            src="@/assets/zsLiveImage/video_voice.png"
            style="width: 24px; height: 24px; padding: 0; display: block"
          />
          <img
            v-if="sound"
            id="player_sound_no_player"
            src="@/assets/zsLiveImage/video_voice_no.png"
            style="width: 24px; height: 24px; padding: 0; display: block"
          />
          <div class="sound-slider-content" v-if="showVolumn">
            <el-slider
              class="sound-slider"
              style="width: 2px; height: 100px; cursor: pointer"
              v-model="soundValue"
              vertical
              @change="getChange"
            ></el-slider>
          </div>
        </div>

        <!-- 画中画 -->
        <div
          class="pictureInPicture"
          @click="openPicInpic"
          @mouseenter="InPicture = true"
          @mouseleave="InPicture = false"
        >
          <img
            v-if="inpic == true && !InPicture"
            :src="require('@/assets/zsLiveImage/video_frame.png')"
            title="画中画"
          />
          <img
            v-if="inpic == true && InPicture"
            :src="require('@/assets/zsLiveImage/video_frame.png')"
            title="画中画"
          />
          <img
            v-if="inpic == false && !InPicture"
            :src="require('@/assets/zsLiveImage/video_frame.png')"
            title="画中画"
          />
          <img
            v-if="inpic == false && InPicture"
            :src="require('@/assets/zsLiveImage/video_frame.png')"
            title="画中画"
          />
        </div>
        <!-- 全屏 -->
        <div id="player_fullscreen_player" @click="showFullscreen">
          <img
            id="player_fullscreen_no_player"
            src="@/assets/zsLiveImage/video_fullScreen_in.png"
            style="width: 24px; height: 24px; padding: 0px; display: block"
          />
        </div>
        <!-- 播放 -->
        <div id="play_or_plause_player">
          <img
            id="play_or_pause_play_player"
            v-if="!isPlay"
            @click="onPlayerPlay"
            src="@/assets/close.png"
            style="width: 24px; height: 24px"
          />
          <img
            id="play_or_pause_pause_player"
            v-if="isPlay"
            @click="onPlayerPause"
            src="@/assets/open.png"
            style="width: 24px; height: 24px"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "videojs-contrib-hls";
import { timeshift } from "@/api/cloudLive/tv";
import { programPageNotoken } from "@/api/cloudLive/program";
import { format } from "date-fns";

export default {
  name: "",
  components: { videoPlayer },
  props: {
    sourceUrl: {
      type: String,
      default: "",
    },
    livePwId: {
      type: Number,
      default: 0,
    },
    resolutionSwitch: {
      type: Boolean,
      default: false,
    },
    liveTimeShiftFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      userid: "",
      urlId: "",
      urlTimer: null, //播放url节点延时器,30秒请求接口1次
      // 请求节目单日期列表
      proIndex: 6, // 列表标识
      program: [],
      openData: false,
      timer: null,
      newScalePlayer: 0, // 当前时间的时间轴偏移量
      pointerLeft: 0, // 节点默认偏移量
      time: 0, // 当前时间
      step: 0, // 左右按钮
      soundValue: 100,
      newSoundValue: 100,
      sound: false, // 音量
      fullscreen: false, // 全屏
      isProess: false, // 时移
      isPlay: false, // 播放/暂停
      initialized: false,
      inpic: false, // 画中画false展示未进入状态,点击进入
      InPicture: false,
      timeShift: true,
      showVolumn: false, // 展示调整音量
      videoDefinitionShow: false, //展示清晰度切换
      currentTech: "",
      streams: {
        rtmp: "",
        hls: "",
      },
      playerOptions: {
        autoplay: true, //如果true,浏览器准备好时开始回放。(好像微信浏览器不太行)
        techOrder: ["html5"], // 需要加载的插件，如果是要兼容flash的话，必须先加载flash。顺序不能错：['flash','html5']
        flash: {
          hls: { withCredentials: false },
        },
        html5: { hls: { withCredentials: false } },
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        language: "zh-CN", // 提示的语言 中文的话是 zh-CN
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度 0.7倍...
        sources: [
          // 播放的资源列表，虽然不知为何是个数组，可能是，轮流播放？
          // {
          //   type: 'video/mp4', // 类型。
          //   src: 'https://download.zsvideo-data.com/opt/zhongshi/2021/11/26/%E5%A4%A9%E4%B9%A6%E5%A5%87%E8%B0%AD%201983_1bdd3b7bb94848d293177937b14fe8dd.mkv' // 视频流路径
          // },
          {
            withCredentials: false, // 直播是否有播放令牌，反正我是没有
            type: "application/x-mpegURL", // m3u8/Hls 的视频流类型
            // src: 'http://192.168.1.65:8081/live/6084677177269168980/index.m3u8' // 对应播放的m3u8 路径
            src: "",
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: true, // 是否显示操作条
        controlBar: {
          // 播放的操作
          timeDivider: false, // 时间分割线
          durationDisplay: false, // 总时间
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      resolution: [],
      definitionDefaultName: "",
      timeShiftHeart:
        new Date().getTime().toString().substr(-8) +
        Math.floor(Math.random() * 10000), // 时移心跳随机数
      programList: [], // 节目单列表
      videoScreen:true,
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    currentStream() {
      return this.currentTech === "Flash" ? "RTMP" : "HLS";
    },
  },
  mounted() {
    this.hiddenOrShow()
    this.urlId = this.livePwId;
    if (this.sourceUrl) {
      var index = this.sourceUrl.lastIndexOf(".");
      var ext = this.sourceUrl.substr(index + 1);
      var ipos = ext.indexOf("?") || ext; //指定开始的字符串
      let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前

      if (str1 == "m3u8") {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      } else if (ext == "flv") {
        this.playerOptions.sources[0].type = "video/x-flv";
      } else if (ext == "mov") {
        this.playerOptions.sources[0].type = "rtmp/mp4";
      } else {
        this.playerOptions.sources[0].type = "video/mp4";
        // this.playerOptions.autoplay = false
      }
      this.playerOptions.sources[0].src = this.sourceUrl;
    }
  },
  watch: {
    sourceUrl(newValue) {
      var index = this.sourceUrl.lastIndexOf(".");
      var ext = this.sourceUrl.substr(index + 1);
      var ipos = ext.indexOf("?") || ext; //指定开始的字符串
      let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
      if (str1 == "m3u8") {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      } else if (ext == "flv") {
        this.playerOptions.sources[0].type = "video/x-flv";
      } else if (ext == "mov") {
        this.playerOptions.sources[0].type = "rtmp/mp4";
      } else {
        this.playerOptions.sources[0].type = "video/mp4";
      }
      this.playerOptions.sources[0].src = newValue;
    },
    livePwId(newValue) {
      console.log(newValue);
      this.urlId = newValue;
    },
    videoScreen(newValue){
      console.log(newValue ,'222222222222222222');
      this.videoScreen = newValue
    }
  },
  methods: {
    isDuringDate(beginDateStr, endDateStr) {
      console.log(beginDateStr, endDateStr);
      var curDate = new Date(),
        beginDate = new Date(beginDateStr),
        endDate = new Date(endDateStr);
      if (curDate >= beginDate && curDate <= endDate) {
        return true;
      }
      return false;
    },
    changRefs(){
      this.$refs.controlBbar.style.display = 'block'
      this.hiddenOrShow()
    },
    hiddenOrShow(){
      setTimeout(() => {
        this.$refs.controlBbar.style.display = 'none'
      }, 3000);
    },
    // 点击视频节目单
    handleClickProgramItem(item) {
      if (item.livePlaybackFlag) {
        this.getProgramUrl(
          this.urlId,
          Math.round(new Date(item.livePlayTime)),
          item.startTime
        );
      }
      console.log(item);
    },
    // 将时间节点拖回节目单起点
    getProgramUrl(id, time, startTime) {
      let obj = {
        begintime: time,
        id: id,
        userid: this.timeShiftHeart,
      };
      clearInterval(this.urlTimer);
      this.urlTimer = null;
      timeshift(obj).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          console.log(res.data.msg);
          this.timeShiftHeart =
            new Date().getTime().toString().substr(-8) +
            Math.floor(Math.random() * 10000);
          this.playerOptions.sources[0].src = res.data.msg;
          // res.data.message:当前播放流路径
          this.$nextTick(() => {
            this.playerOptions.autoplay = true;
            this.getHeartbeat(0);
          });
          this.createdNode("program_item", startTime);
          clearInterval(this.urlTimer);
          this.urlTimer = null;
          if (this.liveTimeShiftFlag) {
            this.createdUrl();
          }
        }
      });
    },
    // 将时分秒时间格式转换成秒
    makeDurationToSeconds(time) {
      var str = time;
      var arr = str.split(":");
      var hs = parseInt(arr[0] * 3600);
      var ms = parseInt(arr[1] * 60);
      var ss = parseInt(arr[2]);
      var seconds = hs + ms + ss;
      return seconds;
    },
    // 动态设置分辨率数组功能
    setResolution(list) {
      // 由父组件传入list 子组件使用
      list = list.map((value, index) => {
        if (index == 0) {
          value.active = true;
        } else {
          value.active = false;
        }
        return value;
      });
      this.resolution = list;
      // 设置第一项为清晰度默认值
      this.definitionDefaultName = list[0].liveTvResolutionName;
    },
    // 切换分辨率
    handleChangeDefinition(item, index) {
      console.log(item);
      this.definitionDefaultName = item.liveTvResolutionName;
      this.handleChangeVideoSrc(item.liveTvResolutionPath);
      this.resolution = this.resolution.map((val, ind) => {
        if (ind == index) val.active = true;
        else val.active = false;
        return val;
      });
      // 切换视频流
    },
    // 动态切换视频流
    handleChangeVideoSrc(newValue) {
      var index = this.sourceUrl.lastIndexOf(".");
      var ext = this.sourceUrl.substr(index + 1);
      var ipos = ext.indexOf("?") || ext; //指定开始的字符串
      let str1 = ipos == -1 ? ext : ext.substring(0, ipos); //取前部分（指定开始的字符串的之前
      if (str1 == "m3u8") {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      } else if (ext == "flv") {
        this.playerOptions.sources[0].type = "video/x-flv";
      } else if (ext == "mov") {
        this.playerOptions.sources[0].type = "rtmp/mp4";
      } else {
        this.playerOptions.sources[0].type = "video/mp4";
      }
      this.playerOptions.sources[0].src = newValue;
      console.log(this.playerOptions.sources[0].src);
    },
    onPlayerReadied() {
      if (!this.initialized) {
        this.initialized = true;
        this.currentTech = this.player.techName_;
      }
    },
    // record current time
    onTimeupdate(e) {
      // 时间
    },
    enterStream() {
      this.playerOptions.sources[0].src = this.streams.hls;
      this.playerOptions.autoplay = true;
    },
    changeTech() {
      if (this.currentTech === "Html5") {
        this.playerOptions.techOrder = ["html5"];
      } else if (this.currentTech === "Flash") {
        this.playerOptions.techOrder = ["flash"];
      }
      this.playerOptions.autoplay = true;
    },

    //播放状态改变回调
    playerStateChanged(playerCurrentState) {
      if (playerCurrentState.canplay) {
        this.loading = false;
      }
    },
    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied(player) {
      console.log("example player 1 readied", player);
    },
    onError() {
      // this.$message.warning('播放错误!')
    },
    onPlayerPlay() {
      // 播放
      this.$refs.videoPlayer.player.play(); // 播放
      this.isPlay = true;
      // this.createdNode()
      clearInterval(this.urlTimer);
      this.urlTimer = null;
      if (this.liveTimeShiftFlag) {
        this.createdUrl();
      }
    },
    onPlayerPause() {
      this.$refs.videoPlayer.player.pause(); // 暂停
      this.isPlay = false;
      this.disNode();
      this.$forceUpdate();
      clearInterval(this.urlTimer);
      this.urlTimer = null;
      // this.getHeartbeat(1)
    },
    // 节点定时器
    createdNode(res, startTime) {
      this.disNode();
      if (res == "program_item") {
        console.log(this.$refs.epgWidth.clientWidth);
        console.log(parseInt(this.$refs.pointer.style.left));
        this.$refs.pointer.style.left =
          this.makeDurationToSeconds(startTime) * 0.15 + "px";
        let epgboxWidth = this.$refs.epgWidth.clientWidth;
        this.timer = setInterval(function () {
          pointerLeft += 9 / 60;
          if (pointerLeft > parseInt(epgboxWidth) + 120) {
            this.$refs.pointer.style.left = parseInt(epgboxWidth) + 100 + "px";
          } else {
            this.$refs.pointer.style.left = pointerLeft + "px";
          }
          console.log(pointerLeft);
        }, 1000);
      } else {
        console.log(this.$refs);
        let pointerLeft = parseInt(this.$refs.pointer.style.left);
        let epgboxWidth = this.$refs.epgWidth.clientWidth;
        this.timer = setInterval(function () {
          pointerLeft += 9 / 60;
          if (pointerLeft > parseInt(epgboxWidth) + 120) {
            this.$refs.pointer.style.left = parseInt(epgboxWidth) + 100 + "px";
          } else {
            this.$refs.pointer.style.left = pointerLeft + "px";
          }
        }, 1000);
      }
    },
    showProess() {
      // 时移
      this.isProess = !this.isProess;
      console.log(this.isProess);
      this.playerOptions.controls = false;
      this.$forceUpdate();
      this.$nextTick(() => {
        this.$refs.epgWidth.style.width =
          parseInt(this.$refs.controlBbar.clientWidth) - 128 + "px";
        this.backLive();
        if (this.isProess) {
          this.createdNode();
          this.getProgramList();
        }else{
          this.disNode()
        }
      });
    },
    format,
    // 获今日取节目单list
    getProgramList() {
      let data = {
        beginTime: format(new Date(), "yyyyMMdd"),
        liveTvId: this.$route.query.liveTvId,
        webTenId:
          this.$route.query.webTenId ||
          JSON.parse(window.localStorage.getItem("user")).webTenId,
      };
      programPageNotoken(data).then((res) => {
        if (res.data.code == 200) {
          this.programList = res.data.data.list;
        }
      });
    },
    showFullscreen() {
      let element = this.$refs.video_box;
      
        // 判断是否已经是全屏
        // 如果是全屏，退出
        if (this.fullscreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            console.log('已还原！');
            this.videoScreen = true
            this.$emit("fullScreen",false)
        } else {    // 否则，进入全屏
          
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullscreen();
            }
            this.videoScreen = false
            console.log('已全屏！');
            this.$emit("fullScreen",true)

        }
        console.log(this.videoScreen,'==============');
        // 改变当前全屏状态
        this.fullscreen = !this.fullscreen;
    },
    getChange() {
      console.log(this.player);
      this.sound = false;
      this.newSoundValue = this.soundValue;
      this.player.cache_.lastVolume = this.newSoundValue / 100;
      this.player.volume(this.player.cache_.lastVolume);
    },
    showSound() {
      //声音
      this.sound = !this.sound;
      if (this.sound) {
        this.soundValue = 0;
        this.player.cache_.lastVolume = this.soundValue / 100;
        this.player.volume(this.player.cache_.lastVolume);
      } else {
        this.soundValue = this.newSoundValue;
        this.player.cache_.lastVolume = this.soundValue / 100;
        this.player.volume(this.player.cache_.lastVolume);
      }
    },
    // 与后端定时交互 告知视频仍在运行
    createdUrl() {
      let that = this;
      if (that.urlTimer) {
        that.clearInterval(that.urlTimer);
        that.urlTimer = null;
      } else {
        that.urlTimer = setInterval(function () {
          that.getHeartbeat(0);
        }, 600 * 10);
      }
    },
    getHeartbeat(item) {
      let obj = {
        state: item,
        userid: this.timeShiftHeart,
      };
      timeshift(obj).then((res) => {
        if (res.data.code == 200) {
          console.log(res.data.msg);
        } else {
        }
      });
    },

    // 获取当前节点url
    getUrl(id, time) {
      let obj = {
        begintime: time,
        id: id,
        userid: this.timeShiftHeart,
      };
      clearInterval(this.urlTimer);
      this.urlTimer = null;
      timeshift(obj).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          console.log(res.data.msg);
          this.timeShiftHeart =
            new Date().getTime().toString().substr(-8) +
            Math.floor(Math.random() * 10000);
          this.playerOptions.sources[0].src = res.data.msg;
          // res.data.message:当前播放流路径
          this.$nextTick(() => {
            this.playerOptions.autoplay = true;
            this.getHeartbeat(0);
          });
          this.createdNode();
          clearInterval(this.urlTimer);
          this.urlTimer = null;
          if (this.liveTimeShiftFlag) {
            this.createdUrl();
          }
        }
      });
    },
    // 获取当前日期节目单
    getDatePro(item, index) {
      this.proIndex = index;
    },
    // 返回直播
    backLive() {
      this.onPlayerPause();
      // 获取当前时间
      let hours = new Date().getHours();
      let minutes = new Date().getMinutes();
      this.time = hours * 60 + minutes;
      this.pointerLeft = parseInt(this.$refs.pointer.style.left) - 110;
      this.$refs.epgPlayer.style.left =
        -this.time * 9 + 30 + this.pointerLeft + "px"; // 当表单偏移量
      this.$refs.scalePlayer.style.left =
        -this.time * 9 + 60 + this.pointerLeft + "px"; // 当时间偏移量
      this.newScalePlayer = -this.time * 9 + 60 + this.pointerLeft;
      this.step = -parseInt((this.time * 9 + 60 + this.pointerLeft) / 800) + 1; // 当前步进值
    },
    // 请求当前时间直播流
    getNewDateUrl() {
      this.playerOptions.sources[0].src = "";
    },
    // 销毁定时器
    disNode() {
      if(this.timer){
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 左按钮
    leftClick() {
      this.onPlayerPause();
      this.$refs.pointer.style.display = "none";
      if (this.step == 0) {
        this.step = 0;
        this.$refs.epgPlayer.style.left = "-30px";
        this.$refs.scalePlayer.style.left = "0px";
      } else {
        this.step++;
        this.$refs.epgPlayer.style.left = this.step * 800 + "px";
        this.$refs.scalePlayer.style.left = this.step * 800 - 30 + "px";
      }
    },
    // 右按钮
    rightClick() {
      this.onPlayerPause();
      this.$refs.pointer.style.display = "none";
      let epgboxWidth = this.$refs.epgWidth.clientWidth;
      let maxWidth = this.$refs.scalePlayer.clientWidth;
      if (this.step == -13) {
        this.step = -13;
        this.$refs.epgPlayer.style.left =
          -parseInt(maxWidth) + parseInt(epgboxWidth) + 30 + "px";
        this.$refs.scalePlayer.style.left =
          -parseInt(maxWidth) + parseInt(epgboxWidth) + 60 + "px";
      } else {
        this.step--;
        this.$refs.epgPlayer.style.left = this.step * 800 + "px";
        this.$refs.scalePlayer.style.left = this.step * 800 - 30 + "px";
      }
    },
    // 节点拖动
    getPointer() {
      console.log("333333333333333333");
      // this.onPlayerPause();
      this.disNode();
      var that = this;
      var epgboxWidth = this.$refs.epgWidth.clientWidth;
      document.getElementsByTagName("img")[0].onmousedown = function (e) {
        e.preventDefault();
      };
      document.onmousemove = function (e) {
        e.preventDefault();
        let nodeLeft = that.$refs.scalePlayer.style.left;
        let newNode =
          Math.abs(parseInt(that.newScalePlayer) - that.pointerLeft) +
          120 +
          360;
        let getNode = Math.abs(parseInt(nodeLeft) - e.pageX);
        if (newNode > getNode) {
          // 如果点击节点小于当前时间节点,允许跳转,否则不执行
          that.$refs.pointer.style.left = e.pageX - 360 + "px";
          if (e.pageX - 360 < 67) {
            that.$refs.pointer.style.left = 67 + "px";
          } else if (e.pageX - 360 > parseInt(epgboxWidth) + 120) {
            that.$refs.pointer.style.left = parseInt(epgboxWidth) + 100 + "px";
          }
        } else {
          // this.playerOptions.sources[0].src ='http://192.168.1.65:8081/live/6084677177269168980/index.m3u8'
        }
      };
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
        let nodeLeft = that.$refs.scalePlayer.style.left;
        let pointerLeft = that.$refs.pointer.style.left;
        let PointerNode = parseInt(nodeLeft) - parseInt(pointerLeft) - 10 + 60; // 偏移长度
        let hours = parseInt(PointerNode / 9 / 60);
        let minutes = parseInt(PointerNode / 9 - hours * 60);
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let timeCode =
          yy +
          "-" +
          mm +
          "-" +
          dd +
          " " +
          Math.abs(hours) +
          ":" +
          Math.abs(minutes); // 时间戳
        that.getUrl(that.urlId, Math.round(new Date(timeCode)));
        that.createdNode();
        clearInterval(that.urlTimer);
        that.urlTimer = null
        if (this.liveTimeShiftFlag) {
          this.createdUrl();
        }
      };
    },
    // 获取鼠标节点毫秒数
    getPointerNode(e) {
      console.log(e);
      this.onPlayerPause();
      this.disNode();
      let nodeLeft = this.$refs.scalePlayer.style.left; // 时间偏移量
      let newNode =
        Math.abs(parseInt(this.newScalePlayer) - this.pointerLeft) + 120 + 360; // 当前时间节点
      let getNode = Math.abs(parseInt(nodeLeft) - e.pageX - 10); // 鼠标点击节点
      if (newNode > getNode) {
        // 如果点击节点小于当前时间节点,允许跳转,否则不执行
        this.$refs.pointer.style.display = "block"; // 展示节点
        this.$refs.pointer.style.left = e.pageX - 10 - 360 + "px"; // 设置节点位置

        let pointerLeft = this.$refs.pointer.style.left;
        let PointerNode = parseInt(nodeLeft) - parseInt(pointerLeft) - 10 + 60; // 偏移长度
        let hours = parseInt(PointerNode / 9 / 60); // 计算当前节点时间 小时
        let minutes = parseInt(PointerNode / 9 - hours * 60); // 计算当前节点时间 分钟
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let timeCode =
          yy +
          "-" +
          mm +
          "-" +
          dd +
          " " +
          Math.abs(hours) +
          ":" +
          Math.abs(minutes); // 时间戳
        console.log(timeCode);
        this.getUrl(this.urlId, Math.round(new Date(timeCode)));
      }
    },
    // 画中画
    openPicInpic() {
      console.log(this.player);
      let video = document.querySelector(".vjs-tech");
      var that = this;
      video.addEventListener("enterpictureinpicture", function () {
        that.inpic = true;
      });
      video.addEventListener("leavepictureinpicture", function () {
        that.inpic = false;
      });
      if (video !== document.pictureInPictureElement) {
        this.player.requestPictureInPicture();
      } else {
        document.exitPictureInPicture();
      }
    },
    //展开调整音量
    handleClickVolumn() {
      this.showVolumn = !this.showVolumn;
    },
    // 打开清晰度切换
    handleClickDefinition() {
      this.videoDefinitionShow = !this.videoDefinitionShow;
    },
  },
  beforeDestroy() {
    this.disNode()
  },
};
</script>
<style>
.vjs-big-play-button {
  display: none !important;
}
.video-js.vjs-fullscreen,
.video-js .vjs-tech,
.vjs-text-track-display {
  z-index: 0 !important;
}
.video-js .vjs-modal-dialog {
  display: none;
  z-index: 0 !important;
}
.vjs-control-bar {
  display: none !important;
}
.sound-slider-content .el-slider__bar {
  background-color: #3d7ddc !important;
}
.sound-slider-content .el-slider.is-vertical .el-slider__runway {
  margin: 0 !important;
  width: 2px;
}
.sound-slider-content .el-slider.is-vertical .el-slider__bar {
  width: 2px;
}
.sound-slider-content .el-slider.is-vertical .el-slider__button-wrapper {
  left: -17px;
}
.sound-slider-content .el-slider__button {
  height: 6px;
  width: 6px;
  background: #3d7ddc;
  border: none;
}
/* .video-js.vjs-fluid{
  position: static;
} */
</style>
<style  lang="scss" scoped>
@import "../assets/css/zscmsLiveMixin.scss";
// 定义响应式css
.zs_control_bar_player {
  position: absolute;
  width: 100%;
  height: 50px;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  background-size: 100% 50px;
  background-repeat: repeat-x;
  z-index: 100;
  // 时移
  .timeshiftbtn_player {
    position: absolute;
    bottom: 23px;
    right: 246px;
    height: 24px;
    cursor: pointer;
    z-index: 9;
    display: flex;
    .timeshiftbtn_text_player {
      font-size: 14px;
      width: 32px;
      font-weight: 400;
      color: rgb(180, 180, 180);
      line-height: 24px;
    }
    .timeshiftbtn_image_player {
      line-height: 29px;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      position: relative;
      .timeshiftbtn_true_player {
        width: 40px;
        height: 24px;
        display: table-cell;
        vertical-align: middle;
      }
      .timeshiftbtn_false_player {
        width: 40px;
        height: 24px;
        display: table-cell;
        vertical-align: middle;
      }
      .timeshiftbtn_pointer_true_player {
        position: absolute;
        transition: right 0.2s ease 0s;
        top: 1px;
      }
    }
  }
  // 清晰度切换
  .video_definition_change_content {
    position: absolute;
    bottom: 23px;
    right: 175px;
    width: 48px;
    height: 24px;
    cursor: pointer;
    z-index: 10;
    .video_definition_now {
      width: 100%;
      height: 24px;
      line-height: 24px;
      border-radius: 20px;
      background: #3d7ddc;
      color: #fff;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
    }
    .video_definition_change_body {
      position: absolute;
      bottom: 55px;
      width: 48px;
      height: auto;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      .video_definition_change_item {
        color: #fff;
        font-size: 14px;
        height: 30px;
        width: 100%;
        line-height: 30px;
        text-align: center;
      }
      .video_definition_item_now {
        color: #3d7ddc;
      }
    }
  }
  // 音量按钮
  #player_sound_btn_player {
    position: absolute;
    bottom: 14px;
    right: 126px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    z-index: 16;
    .sound-slider-content {
      position: absolute;
      bottom: 55px;
      width: 24px;
      height: 120px;
      background: rgba(0, 0, 0, 0.5);
      .sound-slider {
        // position: absolute;
        top: 10px;
        // right: 110px;
        margin: 0 auto;
        cursor: pointer;
        z-index: 10;
      }
    }
  }
  // 画中画按钮
  .pictureInPicture {
    position: absolute;
    bottom: 14px;
    right: 79px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    z-index: 10;
  }
  // 全屏按钮
  #player_fullscreen_player {
    position: absolute;
    bottom: 14px;
    right: 32px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    z-index: 10;
  }
  #play_or_plause_player {
    position: absolute;
    left: 30px;
    width: 30px;
    height: 28px;
    cursor: pointer;
    z-index: 10;
    bottom: 12px;
  }
}

.epg-player-btn {
  width: 12px;
  height: 15px;
  padding: 0px;
  display: block;
  margin: auto;
}
.second-epg {
  display: none;
}
#epg_right_shift_player:hover .second-epg {
  display: block;
}
#epg_right_shift_player:hover .first-epg {
  display: none;
}
#epg_left_shift_player:hover .second-epg {
  display: block;
}
#epg_left_shift_player:hover .first-epg {
  display: none;
}
#timeshift_pointer_player {
  position: absolute;
  bottom: 64px;
  width: 20px;
  height: 70px;
  cursor: pointer;
  z-index: 12;
  display: block;
  transition: left 0s ease 0s;
}
#timeshift_epg_player {
  position: absolute;
  height: 30px;
  bottom: 0px;
  left: 90px;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
  cursor: auto;
  width: 790px;
}
#epg_player {
  position: relative;
  left: -30px;
  height: 30px;
  width: 12960px;
  border-bottom: 1px solid rgb(90, 90, 90);
  margin: 0px;
  padding: 0px;
  color: rgb(255, 255, 255);
  transition: left 0s ease 0s;
  display: flex;
}
#timeshift_scale_player {
  position: absolute;
  height: 20px;
  width: auto;
  bottom: 30px;
  left: 60px;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
  cursor: auto;
}
#scale_player {
  position: relative;
  font-size: 12px;
  left: 0px;
  height: 19px;
  width: 12960px;
  border-bottom: 1px solid rgb(90, 90, 90);
  margin: 0px;
  padding: 0px;
  transition: left 0s ease 0s;
  cursor: pointer;
}
#timeshift_time_player {
  position: absolute;
  bottom: 17px;
  width: auto;
  left: 66px;
  height: 37px;
  font-size: 14px;
  line-height: 37px;
  z-index: 9;
  display: none;
}
#date_list_player {
  position: absolute;
  display: block;
  opacity: 0.9;
  padding: 0px 10px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 37px;
  bottom: 90px;
  left: 0px;
  color: #fff;
  z-index: 16;
}
#timeshift_bar_player {
  position: absolute;
  display: block;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  height: 50px;
  width: 100%;
  bottom: 70px;
  left: 0px;
  margin: 0px;
  padding: 0px;
  color: rgba(255, 255, 255, 0.804);
  background-image: url("../assets/ckVideo/controls_bg_live.png");
  background-size: 100% 50px;
  background-repeat: repeat-x;
  z-index: 9;
}
.program-list {
  cursor: pointer;
  padding: 0px 10px;
  margin: 0px;
  background-color: rgb(38, 38, 38);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
#date_list_player .is-active {
  color: #f09;
}
.program_item {
  color: #fff;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  top: 0;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
}
.program_item_playing {
  background: #3d7ddc;
}
.mask{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 90;
  background-color: rgba(0,0,0,0);
}
/deep/.video-js.vjs-fluid{
  position: static;
}
</style>
